import axios from "axios";
import { workerActions } from "../../../../store/slices/workers";
import { warehouseActions } from "../../../../store/slices/warehouse";

export const getGreylistId = "greylist";
export const greylistDataId = 'greylists'

const getGreylist = ({ controller, server, cloner_key, repoId: repoid }) => {
  return async (dispatch) => {
    dispatch(workerActions.start("greylists"));
    try {
      const response = await axios.get(server + "api/greylist", {
        signal: controller.signal,
        headers: { cloner_key },
        params: { repoid },
      });

      const versions = response.data.versions;
      let versionsArray = [];
      for (const version in versions) {
        const milliseconds = Date.parse(versions[version].created);
        const localCreated = new Date(versions[version].created).toLocaleString(
          "es-CL"
        );
        versionsArray.push({
          tree: versions[version].greylist,
          repo: versions[version].repoid,
          size: versions[version].size,
          created: versions[version].created,
          milliseconds,
          localCreated,
        });
      }
      versionsArray.reverse();

      dispatch(warehouseActions.load({ id: greylistDataId, data: versionsArray }));
      dispatch(workerActions.finish({ id: getGreylistId }));
    } catch (e) {
      console.error(e);
      dispatch(workerActions.finish({ id: getGreylistId, error: e.message }));
    }
  };
};

export default getGreylist;
